module.exports = __webpack_public_path__ + "static/img/logo.3a1cd8d9.3a1cd8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productStage/logo.3a1cd8d9.png
// module id = D4cD
// module chunks = 44